import { FileUpload } from '../../models/Entities/Contracts/FileUpload';
import { ErrorType } from '../../models/HttpError';
import { HttpResult } from '../../models/HttpResult';

export interface FileUploadState {
    FileUploads: FileUpload[];
    EditingFileUpload?: FileUpload;
    FileUploadResult?: HttpResult<any>;
    TotalCount: number;

    // Loading all files state
    isLoadingAll: boolean;
    successLoadingAll: boolean | undefined;
    failOnLoadingAll: boolean;
    
    // Upload file state
    isUploadingFile: boolean;
    successUploadingFile: boolean | undefined;
    failOnUploadingFile: boolean;
    
    // Download file state
    isDownloadingFile: boolean;
    successDownloadingFile: boolean | undefined;
    failOnDownloadingFile: boolean;
    
    // Update file state
    isUpdatingFile: boolean;
    successUpdatingFile: boolean | undefined;
    failOnUpdatingFile: boolean;

    // Delete file state
    isDeletingFile: boolean;
    successDeletingFile: boolean | undefined;
    failOnDeletingFile: boolean;
    
    error?: ErrorType;
}

export const FileUploadUnloadState: FileUploadState = {
    FileUploads: [],
    EditingFileUpload: undefined,
    FileUploadResult: undefined,
    TotalCount: 0,

    // Loading all files state
    isLoadingAll: false,
    successLoadingAll: undefined,
    failOnLoadingAll: false,
    
    // Upload file state
    isUploadingFile: false,
    successUploadingFile: undefined,
    failOnUploadingFile: false,
    
    // Download file state
    isDownloadingFile: false,
    successDownloadingFile: undefined,
    failOnDownloadingFile: false,
    
    // Update file state
    isUpdatingFile: false,
    successUpdatingFile: undefined,
    failOnUpdatingFile: false,

    // Delete file state
    isDeletingFile: false,
    successDeletingFile: undefined,
    failOnDeletingFile: false,
    
    error: undefined
};
